import { useLocation } from 'react-router-dom';
import type { StoreApi, UseBoundStore } from 'zustand';
import { ComponentWithValues } from 'common/stack/ComponentWithValuesDocuments';
import { StackConfig } from 'common/stack/StackConfigDocuments';
import { useDeploymentClientState } from 'client/state/DeploymentClientState';
import { useProjectState } from 'client/state/ProjectState';

export type ProjectOrDeploymentState = {
  document?: {
    stage?: string;
    stackConfig: StackConfig;
    componentsWithValues: ComponentWithValues[];
    repositoryUrl: string | null;
    repositoryRef: string | null;
  } | null;
};

export const getProjectOrDeployment = (pathname?: string) => {
  const path = (pathname || window.location.pathname).split('/').slice(1);
  if (path.includes('deployment') && path.includes('project')) return 'deployment' as const;
  if (path.includes('project')) return 'project' as const;
  return 'other' as const;
};

export const useProjectOrDeployment = () => {
  const { pathname } = useLocation();
  return getProjectOrDeployment(pathname);
};

export const getProjectOrDeploymentState = (pathname?: string): UseBoundStore<StoreApi<ProjectOrDeploymentState>> => {
  const view = getProjectOrDeployment(pathname);
  if (view === 'deployment') return useDeploymentClientState;
  if (view === 'project') return useProjectState;
  throw new Error('Component hooks used outside of a project or deployment');
};

// @ts-expect-error I dont know how to fix this error, but the types are correct so lets just roll with it
export const useProjectOrDeploymentState: UseBoundStore<StoreApi<ProjectOrDeploymentState>> = (selector) => {
  const { pathname } = useLocation();
  return getProjectOrDeploymentState(pathname)(selector);
};

export const useProjectOrDeploymentProjectID = () => {
  const { pathname } = useLocation();
  const view = getProjectOrDeployment(pathname);
  if (view === 'deployment') return useDeploymentClientState((state) => state.project?.id);
  if (view === 'project') return useProjectState((state) => state.document?.id);
  throw new Error('Component hooks used outside of a project or deployment');
};
